<template>
  <div class="contents">
    <div class="contents__inner">
      <v-card-title>Videos - {{this.$route.params.artistName}}</v-card-title>
        <v-app>
            <div v-for="item in musicWithVideos" :key="item.name">
             <YoutubeContainer :id="item.url_youtube" />
            </div>
        </v-app>
    </div>
  </div>
</template>

<script>
import YoutubeContainer from "../components/YoutubeContainer";
import { getMusicInfo } from "../functions/artists-function";

export default {
  data() {
    return {
      musicWithVideos: []
    };
  },
  components:{
    YoutubeContainer
  },
  watch: {
    "$route.params.artistName": function() {
      this.getMusicWithVideos();
    }
  },
  methods: {
    getMusicWithVideos: async function() {
      const music = await getMusicInfo(this.$route.params.artistName);
      let musicWithVideos = [];
      music.forEach(m => {
        if (m.url_youtube === "" || m.url_youtube === undefined) return;
        musicWithVideos.push(m);
      });
      this.musicWithVideos = musicWithVideos;
    }
  },
  mounted: function() {
    this.getMusicWithVideos();
  }
};
</script>

<style lang="scss" scoped>
.contents {
  margin-top: 2em;

  &__inner {
    max-width: 860px;
    margin-left: auto;
    margin-right: auto;
  }
}

a img:hover {
  filter: brightness(0.5);
}

.videoImg {
  width: 270px;
  height:270px;
}

.v-card__title {
  padding: 16px 0 8px 0;
}

.widthBox {
  flex-basis: 33.3333333333%;
  flex-grow: 0;
  max-width: 33.3333333333%;
}

@media screen and (max-width: 1024px) {

  .contents {

    &__inner {
      max-width: 680px;
    }
  }

  .videoImg {
    width: 200px;
    height:200px;
    }

  .widthBox {
    flex-basis: auto;
  }

  .layout.wrap {
    justify-content: space-between;
  }

}

@media screen and (max-width: 480px) {
  .contents {
    &__inner {
      margin: 0 30px;
    }
  }

  .videoImg {
    width: 100%;
    height: auto;
  }
  
  .widthBox {
    flex-basis: 100%;
    max-width: 100%;
  }


}


</style>
